export default "__VITE_ASSET__BvdPTrK7__"